import React, {
    useState,
    useEffect,
    useContext,
    Fragment,
    useCallback,
  } from 'react';
  import Layout from 'components/sales/layout/layout';
  import localization from 'assets/localization/localization';
  import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
  import { Button, Table } from 'react-bootstrap';
  import Images from 'assets/images/imageData';
  import ModalPop from 'components/sales/modal/modal';
  import { Link } from 'react-router-dom';
  import { BaseUrl } from 'contexts/baseUrl/baseUrl';
  import DocumentView from 'components/sales/downloadDocView/documentView';
  import DivLayout from 'components/sales/divLayout/divLayout';
  import moment from 'moment';
import {getHelpdeskDetail} from "../../../../services/redux/brandActivtion/conductCamp/action";
  
  const HelpdeskDetails = ({
    getHelpdeskDetail,
    HelpdeskDetails,
    match,
    history,
  }) => {
    const [details, setDetails] = useState(null);
    const { baseUrl } = useContext(BaseUrl);
    const [isModal, setIsModal] = useState(false);
    const [isStatusModal, setIsStatusModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isCancelModal, setIsCancelModal] = useState(false);
    const [isCompleteModal, setIsCompleteModal] = useState(false);
  
    const getMeeting = useCallback(async () => {
      if (match?.params?.id) {
        setIsLoading(true);
        await getHelpdeskDetail(match?.params?.id);
        setIsLoading(false);
      }
    }, [getHelpdeskDetail, match?.params?.id]);
  
    useEffect(() => {
      getMeeting();
    }, [getMeeting]);
  
    useEffect(() => {
      if (HelpdeskDetails) {
        setDetails(HelpdeskDetails);
      }
    }, [HelpdeskDetails]);
  
    
    return (
      <Layout
        title={localization.helpdeskDetails}
        isGoback
        isLoading={isLoading}
        linkFlag
        linkUrl={`${baseUrl}/brand-activation/helpdesk`}
      >
        {details && details.carnival && Object.keys(details?.carnival).length !== 0 ? (
          <div className="panel-card">
            <div className="panel-heading">{localization.helpdeskDetails}</div>
            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={localization.projectId}
                  data={
                    details?.carnival?.infra_id
                      ? details?.carnival?.infra_id
                      : ''
                  }
                />
                <DivLayout
                  heading={localization.siteName}
                  data={
                    details?.carnival?.name
                      ? details?.carnival?.name
                      : ''
                  }
                />
                <DivLayout
                  heading={localization.startDate}
                  data={
                    details?.carnival?.start_date
                      ? details?.carnival?.start_date
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.startTime}
                  data={
                    details?.carnival?.start_time
                      ? details?.carnival?.start_time
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.endDate}
                  data={
                    details?.carnival?.end_date
                      ? details?.carnival?.end_date
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.endTime}
                  data={
                    details?.carnival?.end_time
                      ? details?.carnival?.end_time
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.status}
                  data={
                    details?.carnival?.status_name
                      ? details?.carnival?.status_name
                      : localization.na
                  }
                />
              </div>
            </div>
          </div>
        ) : null}

      </Layout>
    );
  };
  
  export default HelpdeskDetails;
  